import React from 'react'

import { IMAGE } from '@ui-kit/assets/images/index.web'
import Icon from '@ui-kit/components/Icon/index.web'
import Switch from '@ui-kit/components/formComponents/Switch/index.web'
import { body2, caption, h4 } from '@ui-kit/core/typography'

import * as styles from './styles'
import type { WebProps } from './types'

const SwitchCard = (props: WebProps) => {
  const { container, iconContainer, btn, label, textContainer } = styles.switchCard()
  return (
    <div className={container()} id={props.id}>
      <label className={label()} htmlFor={props.id && `${props.id}-Switch`}>
        {props.icon && <div className={iconContainer()}>{props.icon}</div>}
        <div className={textContainer()}>
          <p className={h4()}>{props.title}</p>
          <p className={caption({ emphasis: 'medium' })}>{props.subtitle}</p>
        </div>
        {props.value !== undefined && (
          <Switch
            id={props.id && `${props.id}-Switch`}
            value={props.value}
            label={props.label}
            onValueChange={props.onValueChange}
            disabled={props.disabled}
          />
        )}
      </label>
      <div>
        <p className={body2()}>{props.description}</p>
        <button className={btn()} type="button" onClick={props.onClick}>
          <span className={caption({ color: 'brandDark' })}>{props.buttonLabel}</span>
          <Icon imgSrc={IMAGE.icons.xsmall.action.chevronRightBrandDark_16} />
        </button>
      </div>
    </div>
  )
}

export default SwitchCard
